import React, { useEffect, useState } from 'react';
import { CButton, CCard, CCardBody } from '@coreui/react';
import SaveExtra from '../../services/general/saveExtraData.api';

const SubmitFinalInfo = ({ diagnosis, formData }) => {
    // Get today's date
    const currentDate = new Date().toLocaleDateString('en-US');
    let [providerName, setProviderName] = useState(null)

    const getAppointmentData = async () => {

        try {
            const result = await SaveExtra('Get_By_Type', 'multiAppointmentsData', '', '');
            const rawData = JSON.parse(result.d)?.Data || [];
            console.log("raw data=====>", rawData);

            let structuredData = [];

            rawData.forEach((item) => {
                let parsedList = JSON.parse(item?.JsonData);

                if (Array.isArray(parsedList)) {
                    parsedList.forEach((parsedItem) => {
                        const patientID = parsedItem?.patientID;
                        const appointmentDetails = parsedItem?.appointmentDetails || [];

                        const formattedAppointments = appointmentDetails.map((appointment) => {
                            const data = appointment?.data || {};
                            const current = appointment?.current || {
                                Patient: { value: data?.PatientID || '', label: data?.AppointmentName || 'Unknown' },
                                Provider: { value: '', label: data?.ProviderName || 'Unknown' },
                                Facility: { value: '', label: data?.Facility || 'Unknown' },
                                Insurance: data?.Insurance || {},
                                otherDetails: data?.otherDetails || {},
                            };

                            return { data, current };
                        });

                        structuredData.push({
                            patientID,
                            appointmentDetails: formattedAppointments,
                        });
                    });
                } else {
                    console.warn("Unexpected non-array parsed data:", parsedList);
                }
            });





            let flatAppointments = structuredData.flatMap(p => p.appointmentDetails);
            // console.log("structuredData data ======>", structuredData, flatAppointments )
            flatAppointments = flatAppointments.filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
            console.log("structuredData data ======>", structuredData, flatAppointments)



            return flatAppointments;
        } catch (error) {
            console.log("Error in getAppointmentData", error);
        } finally {

        }
    };

    useEffect(() => {
        const fetchData = async () => {
            let appointments = await getAppointmentData();
            let providerDetails = appointments?.filter(
                ID => ID.current.Patient.value === formData.PatientID
            );
            if (providerDetails && providerDetails.length > 0) {
                setProviderName(providerDetails[0].current.Provider.label);
            }
        };

        fetchData();
    }, []);


    return (
        <div>
            {diagnosis.map((patient) => (
                <CCard
                    key={patient.Id}
                    className="mb-4"
                    style={{
                        marginTop: '24px',
                        borderRadius: '12px',
                        padding: '20px',
                        border: '1px solid rgb(113, 113, 113)',
                        background: 'var(--ui-bg-modal-body, var(--ui-dashboard-surface, #ffffff))',
                        color: 'var(--ui-text-primary, #000000)',
                    }}
                >
                    <CCardBody>
                        <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>

                            <li
                                style={{
                                    marginBottom: '15px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid rgb(113, 113, 113)',
                                }}
                            >
                                <span>Facility Name:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {patient.FacilityName || 'N/A'}
                                </span>
                            </li>


                            <li
                                style={{
                                    marginBottom: '15px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid rgb(113, 113, 113)',
                                }}
                            >
                                <span>Room:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {patient.Room || 'N/A'}
                                </span>
                            </li>


                            <li
                                style={{
                                    marginBottom: '15px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid rgb(113, 113, 113)',
                                }}
                            >
                                <span>Diagnosis:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {(patient.Diagnosis || '')
                                        .split(',')
                                        .map((item) => item.trim())
                                        .filter(Boolean)
                                        .join(', ') || 'N/A'}
                                </span>
                            </li>


                            <li
                                style={{
                                    marginBottom: '15px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid rgb(113, 113, 113)',
                                }}
                            >
                                <span>Provider Name:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {providerName}
                                </span>

                            </li>


                            <li
                                style={{
                                    marginBottom: '15px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid rgb(113, 113, 113)',
                                }}
                            >
                                <span>Created Date:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {new Date(currentDate).toLocaleDateString('en-US')}
                                </span>
                            </li>
                            <li
                                style={{
                                    marginBottom: '15px',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid rgb(113, 113, 113)',
                                }}
                            >
                                <span>Last Visit Date:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {currentDate}
                                </span>
                            </li>
                            <li>
                                <span>Last Updated Date:</span>
                                <span style={{ marginLeft: '10px', color: 'var(--ui-text-secondary, #555555)' }}>
                                    {currentDate}
                                </span>
                            </li>
                        </ul>
                    </CCardBody>
                </CCard>
            ))}
        </div>


    );
};

export default SubmitFinalInfo;
